<template lang="html">
  <div class="row loyalty-date-range">
    <div class="medium-12">
      <div class="large-5 small-10 medium-6 columns medium-offset-3 small-offset-2 large-offset-4">
        <div class="column small-10 medium-10 large-10">
          <flat-pickr v-if="config" :value="[fromData, toData]" :config="config" name="range"></flat-pickr>
        </div>
        <div class="column small-2 medium-2 large-2">
          <span class="remove-timeframe-link" @click="remove(id)">X</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import flatPickr from 'vue-flatpickr-component'

export default {
  props: {
    id: Number,
    fr: String,
    to: String,
  },

  name: 'DateRange',

  components: {
    flatPickr
  },

  data() {
    return {
      fromData: '',
      toData: '',
    }
  },

  methods: {
    onChange(selectedDates, dateStr) {
      let isValid = this.validateSelectedDates(selectedDates)

      let values = {
        id: this.id,
        isValid: isValid,
        from: this.fromData,
        to: this.toData
      }

      this.$emit('onUpdate', values)
    },

    remove(id) {
      this.$emit('onRemove', id)
    },

    setDateRange(selectedDates) {
      this.fromData = moment(selectedDates[0], 'MM-D-Y').format('MM-D-Y')
      this.toData = moment(selectedDates[1], 'MM-D-Y').format('MM-D-Y')
    },

    validateSelectedDates(selectedDates) {
      let isValid = false

      if (selectedDates.length === 2) {
        this.setDateRange(selectedDates)
        let from = moment(this.fromData, 'MM-D-Y')
        let to = moment(this.toData, 'MM-D-Y')

        let numberOfYears = from.diff(to, 'years', false)
        if (numberOfYears <= 0) {
          isValid = true
        }
      }

      return isValid
    },
  },

  created() {
    this.fromData = this.fr
    this.toData = this.to
  },

  computed: {
    config: function() {
      return {
        mode: 'range',
        altFormat: 'm-d-Y',
        altInput: true,
        altInputClass: 'flatpickr-input',
        enableTime: false,
        dateFormat: 'm-d-Y',
        maxDate: 'today',
        defaultDate: [this.fromData, this.toData],
        onChange: this.onChange
      }
    },
  },
}
</script>
